export const CF_CDN_URL = (route: string) => `https://dyaj6jwzih5dm.cloudfront.net/rebate-widget${route}`;
